<mat-toolbar class="navmenu-container">
    <img class="logo" src="../../assets/spencer-west-logo.png" alt="Logo" routerLink="/">

    <div class="flex-filler"></div>

    <div class="notification-container" *ngIf="isIdVerificationTab" (click)="displayContact()">
        <fa-icon class="notification-icon" [icon]="faBell"></fa-icon>
        <div class="notification-dot" *ngIf="hasNotifications"></div>
    </div>

    <div class="user-info" (click)="toggleDropdown()" tabindex="0">
        <div class="initials-circle">{{ authService.userDetails?.avatar }}</div>
        <h4 class="username">{{ authService.userDetails?.displayName }}</h4>
    </div>

    <div class="custom-user-dropdown" *ngIf="isDropdownOpen" (click)="$event.stopPropagation()">
        <ul>
            <li *ngIf="authService.userDetails?.isAdmin" (click)="navigateToConf(); closeDropdown()">
                <mat-icon>settings</mat-icon>
                <span>Configurations</span>
            </li>
            <li (click)="logout(); closeDropdown()">
                <mat-icon>logout</mat-icon>
                <span>Log Out</span>
            </li>
        </ul>
    </div>

</mat-toolbar>
